'use es6';

import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const StyleProtectedTransparentButton = _ref => {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(Button, Object.assign({
    use: "transparent",
    size: "small",
    paddingInline: "100",
    marginBlockEnd: "25"
  }, props));
};
export default StyleProtectedTransparentButton;